<template>
  <div class="detail-rows">
    <div class='table-content atb-flex atb-flex-column' v-if="isBatch">
      <vxe-table
        class='atb-table header-table edit-table'
        border='inner'
        height='100%'
        auto-resize
        resizable
        stripe
        highlight-hover-row
        highlight-current-row
        :data="tableData"
        :expand-config="{visibleMethod: expandVisibleMethod, iconOpen: 'vxe-icon--caret-bottom', iconClose: 'vxe-icon--caret-right'}"
        @cell-click="expandRow"
        ref="tableEl"
      >
        <vxe-table-column type='seq' width='55' align='center' title="序号"></vxe-table-column>
        <vxe-table-column
          width="120"
          field="titleCol"
          title="标题"
          key="titleCol"
        >
        </vxe-table-column>
        <vxe-table-column field="resWkName" type="expand" title="指定人" width="180">
          <template #default="{ row }">
            <span>{{ row.resWkName }}({{ row.resWkNo }})</span>
            <el-popover
              v-if="row.isShowTransfer"
              width="600"
              trigger="click"
              @show="showTransfer(row)"
            >
              <vxe-table
                class='atb-table header-table edit-table'
                border='inner'
                max-height="500px"
                auto-resize
                resizable
                stripe
                highlight-hover-row
                highlight-current-row
                :data="transferTableData"
                ref="releasedMonthWork"
              >
                <vxe-table-column field="resWkName" title="转出人" width="140">
                  <template #default="{row}">
                    <span>{{ row.extendObj.SenderName }}</span>
                    <span>({{ row.extendObj.SenderNo }})</span>
                  </template>
                </vxe-table-column>
                <vxe-table-column field="DesigneeNo" title="转入人" width="140">
                  <template #default="{row}">
                    <span>{{ row.extendObj.DesigneeName }}</span>
                    <span>({{ row.extendObj.DesigneeNo }})</span>
                  </template>
                </vxe-table-column>
                <vxe-table-column field="transferHandoverApproveNo" title="审批人" width="140">
                  <template #default="{row}">
                    <span>{{ row.transferHandoverApproveName }}</span>
                    <span v-if="row.transferHandoverApproveNo">({{ row.transferHandoverApproveNo }})</span>
                  </template>
                </vxe-table-column>
                <vxe-table-column field="dealDate" title="日期" width="140">
                  <template #default="{row}">
                    <span>{{ formatDate(row.creationTime, 'yyyy-MM-dd') }}</span>
                  </template>
                </vxe-table-column>
                <vxe-table-column field="transferHandoverApproveReason" title="审批意见" width="140"></vxe-table-column>
                <vxe-table-column field="transferHandoverApproveState" title="状态" width="140">
                  <template #default="{row}">
                    <span>{{ getApproveState(row.transferHandoverApproveState) }}</span>
                  </template>
                </vxe-table-column>
                <vxe-table-column field="transferHandoverType" title="转移/交接" width="140">
                  <template #default="{row}">
                    <span>{{ row.transferHandoverType === 'TransferWork' ? '转移' : '交接' }}</span>
                  </template>
                </vxe-table-column>
                <vxe-table-column field="transferHandoverWorkType" title="工作属性" width="140">
                  <template #default="{row}">
                    <span>{{ row.transferHandoverWorkType === 'Month' ? '月' : '年' }}</span>
                  </template>
                </vxe-table-column>
              </vxe-table>
              <i slot="reference" class='el-icon-warning-outline transfer-icon' title="查看转移交接记录"></i>
            </el-popover>
          </template>
          <template #content="{ row, rowIndex }">
            <div class="year-to-month-wrapper" v-if="row.currInYearList && row.currInYearList.length > 0">
              <ExpandTable :detailData="row.currInYearList" dataType="year" :itemType="rowData.type" :yearCompleteList="yearCompleteList" />
            </div>
            <div class="year-to-month-wrapper" v-if="row.currInMonthList && row.currInMonthList.length > 0">
              <ExpandTable :detailData="row.currInMonthList" dataType="month" :itemType="rowData.type" />
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          width="100"
          field="completeStatus"
          title="完成情况"
          v-if="rowData.type === 'month'"
          key="month-completeStatus"
        >
          <template #default="{row}">
            <el-tag v-if="row.completeStatus == 10 || row.completeStatus == 0" type="complete" effect="dark">未完成</el-tag>
            <el-tag v-if="row.completeStatus == 20" type="complete" effect="dark">月目标完成</el-tag>
            <el-tag v-if="row.completeStatus == 25" type="complete" effect="dark">总目标完成</el-tag>
            <el-tag v-if="row.completeStatus == 30" type="complete" effect="dark">延迟</el-tag>
            <el-tag v-if="row.completeStatus == 40" type="complete" effect="dark">转移</el-tag>
            <el-tag v-if="row.completeStatus == 50" type="complete" effect="dark">关闭</el-tag>
          </template>
        </vxe-table-column>
        <vxe-table-column
          width="120"
          field="status"
          title="提交状态"
          v-if="rowData.type === 'year'"
          key="year-status"
        >
          <template #default="{row}">
            <el-tag
              :type="[30, 50, 70].includes(row.status) ? 'close' : 'complete'"
              effect="dark">
              {{getYearStatusName(row.status)}}
            </el-tag>
          </template>
        </vxe-table-column>
        <vxe-table-column width="180" field="reason" title="总结" v-if="rowData.type === 'month'" key="reason">
          <template #default="{row}">
            <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.reason }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          width="160"
          field="firstHalfSummary"
          title="上半年总结"
          v-if="rowData.type === 'year'"
          key="firstHalfSummary"
        >
          <template #default="{row, rowIndex}">
            <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', '', 'atb-flex-items-center']">{{ row.firstHalfSummary }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          width="160"
          field="fullSummary"
          title="全年总结"
          v-if="rowData.type === 'year'"
          key="fullSummary"
        >
          <template #default="{row, rowIndex}">
            <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', '', 'atb-flex-items-center']">{{ row.fullSummary }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          width="150"
          field="workItemContent"
          title="工作项目"
          key="workItemContent"
        >
          <template #default="scope">
            <div :class="[scope.row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ scope.row.workItemContent }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          width="250"
          field="wholeTarget"
          title="总目标"
          v-if="rowData.type === 'month'"
          key="wholeTarget"
        >
          <template #default="{row}">
            <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.wholeTarget }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          width="150"
          field="finishDate"
          title="总目标完成时间"
          v-if="rowData.type === 'month'"
          key="finishDate"
        >
          <template #default="{ row }">{{ formatDate(row.finishDate, 'yyyy-MM-dd') }}</template>
        </vxe-table-column>
        <vxe-table-column
          width="160"
          field="firstHalfTarget"
          title="上半年目标"
          v-if="rowData.type === 'year'"
          key="firstHalfTarget"
        >
          <template #default="{row, rowIndex}">
            <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', '', 'atb-flex-items-center']">{{ row.firstHalfTarget }}</div>
          </template>
        </vxe-table-column>
        
        <vxe-table-column
          width="160"
          field="fullTarget"
          title="全年目标"
          v-if="rowData.type === 'year'"
          key="fullTarget"
        >
          <template #default="{row, rowIndex}">
            <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', '', 'atb-flex-items-center']">{{ row.fullTarget }}</div>
          </template>
        </vxe-table-column>
        
        <vxe-table-column
          width="150"
          field="startDate"
          title="开始日期"
          v-if="rowData.type === 'year'"
          key="startDate"
        >
          <template #default="{ row }">{{ formatDate(row.startDate, 'yyyy-MM-dd') }}</template>
        </vxe-table-column>
        <vxe-table-column
          width="150"
          field="finishDate"
          title="最终完成日期"
          v-if="rowData.type === 'year'"
          key="finishDate"
        >
          <template #default="{ row }">{{ formatDate(row.finishDate, 'yyyy-MM-dd') }}</template>
        </vxe-table-column>
        <vxe-table-column
          width="160"
          field="currentMonthTarget"
          title="本月需达到的目标"
          v-if="rowData.type === 'month'"
          key="currentMonthTarget"
        >
          <template #default="{row, rowIndex}">
            <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', '', 'atb-flex-items-center']">{{ row.currentMonthTarget }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          width="160"
          field="currentMonthFinishDate"
          title="本月目标完成时间"
          v-if="rowData.type === 'month'"
          key="currentMonthFinishDate"
        >
          <template #default="{ row }">{{ formatDate(row.currentMonthFinishDate, 'yyyy-MM-dd') }}</template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div class='page-con atb-flex atb-flex-justify-end' v-if="isBatch">
      <vxe-pager
        background
        :current-page.sync="pageIndex"
        :page-size.sync="pageSize"
        :total="total"
        height="100%"
        @page-change="handledPageChange"
        pager-count="4"
        :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
      >
      </vxe-pager>
    </div>
    <div class="detail-wrap" v-if="!isBatch">
      <div class="detail-item">
        <h3 class="item-title">发布类型</h3>
        <div class="item-content">
          <span v-if="rowData.type === 'year'">年修订</span>
          <span v-if="rowData.type === 'month'">新增工作发布</span>
          <span v-if="rowData.type === 'todoWork'">工作待办</span>
        </div>
      </div>
      <div class="detail-item">
        <h3 class="item-title">工作项分类</h3>
        <div class="item-content">{{ workClassifyName() }}</div>
      </div>
      <div class="detail-item">
        <h3 class="item-title">工作项目</h3>
        <div class="item-content">{{ detailData.workItemContent }}</div>
      </div>
      <div class="detail-item">
        <h3 class="item-title">指定人</h3>
        <div class="item-content">{{ detailData.resWkName ? detailData.resWkName + "(" + detailData.resWkNo + ")" : detailData.resWkNo }}</div>
      </div>
      <div class="detail-item" v-if="rowData.type === 'month'">
        <h3 class="item-title">总目标</h3>
        <div class="item-content">{{ detailData.wholeTarget }}</div>
      </div>
      <div class="detail-item" v-if="rowData.type === 'month'">
        <h3 class="item-title">总目标完成时间</h3>
        <div class="item-content">{{ detailData.finishDate ? formatDate(new Date(detailData.finishDate), 'yyyy-MM-dd') : '' }}</div>
      </div>
      <div class="detail-item" v-if="rowData.type === 'month'">
        <h3 class="item-title">本月需达到的目标</h3>
        <div class="item-content">{{ detailData.currentMonthTarget }}</div>
      </div>
      <div class="detail-item" v-if="rowData.type === 'month'">
        <h3 class="item-title">本月目标完成时间</h3>
        <div class="item-content">{{ detailData.currentMonthFinishDate ? formatDate(new Date(detailData.currentMonthFinishDate), 'yyyy-MM-dd') : '' }}</div>
      </div>
      <div class="detail-item"  v-if="rowData.type === 'year'">
        <h3 class="item-title">上半年目标</h3>
        <div class="item-content">{{ detailData.firstHalfTarget }}</div>
      </div>
      <div class="detail-item"  v-if="rowData.type === 'year'">
        <h3 class="item-title">上半年总结</h3>
        <div class="item-content">{{ detailData.firstHalfSummary }}</div>
      </div>
      <div class="detail-item"  v-if="rowData.type === 'year'">
        <h3 class="item-title">全年目标</h3>
        <div class="item-content">{{ detailData.fullTarget }}</div>
      </div>
      <div class="detail-item"  v-if="rowData.type === 'year'">
        <h3 class="item-title">全年总结</h3>
        <div class="item-content">{{ detailData.fullSummary }}</div>
      </div>
      
      <div class="detail-item">
        <h3 class="item-title">权重</h3>
        <div class="item-content">{{ detailData.weight }}</div>
      </div>
      <div class="detail-item" v-if="rowData.type === 'month'">
        <h3 class="item-title">重点关注</h3>
        <div class="item-content">
          <span v-if='detailData.isImportantWork == 0'>否</span>
          <span v-if='detailData.isImportantWork == 1'>是</span>
        </div>
      </div>
      <div class="detail-item" v-if="rowData.type === 'month'">
        <h3 class="item-title">总结</h3>
        <div class="item-content">{{ detailData.reason }}</div>
      </div>
      <div class="detail-item" v-if="rowData.type === 'month'">
        <h3 class="item-title">完成情况</h3>
        <div class="item-content">
          <el-tag v-if="detailData.completeStatus == 10 || detailData.completeStatus == 0" type="complete" effect="dark">未完成</el-tag>
          <el-tag v-if="detailData.completeStatus == 20" type="complete" effect="dark">月目标完成</el-tag>
          <el-tag v-if="detailData.completeStatus == 25" type="complete" effect="dark">总目标完成</el-tag>
          <el-tag v-if="detailData.completeStatus == 30" type="complete" effect="dark">延迟</el-tag>
          <el-tag v-if="detailData.completeStatus == 40" type="complete" effect="dark">转移</el-tag>
          <el-tag v-if="detailData.completeStatus == 50" type="complete" effect="dark">关闭</el-tag>
        </div>
      </div>
      <div class="detail-item" v-if="rowData.type === 'year'">
        <h3 class="item-title">提交状态</h3>
        <div class="item-content">
          <el-tag
            :type="[30, 50, 70].includes(detailData.status) ? 'close' : 'complete'"
            effect="dark">
            {{getYearStatusName(detailData.status)}}
          </el-tag>
        </div>
      </div>
      <div class="detail-item" v-if="rowData.type === 'year'">
        <h3 class="item-title">开始日期</h3>
        <div class="item-content">{{ detailData.startDate ? formatDate(new Date(detailData.startDate), 'yyyy-MM-dd') : '' }}</div>
      </div>
      <div class="detail-item" v-if="rowData.type === 'year'">
        <h3 class="item-title">最终完成日期</h3>
        <div class="item-content">{{ detailData.finishDate ? formatDate(new Date(detailData.finishDate), 'yyyy-MM-dd') : '' }}</div>
      </div>
      <div class="detail-item">
        <h3 class="item-title">创建时间</h3>
        <div class="item-content">{{ detailData.creationTime ? formatDate(new Date(detailData.creationTime), 'yyyy-MM-dd HH:mm:ss') : '' }}</div>
      </div>
    </div>
  </div>
</template>
<script>
  import XEUtils from 'xe-utils';
  import ExpandTable from './ExpandTable.vue';
  export default {
    name: 'RowDetail',
    components: {
      ExpandTable,
    },
    props: {
      rowData: Object,
      workClassifyList: Array,
      monthWorkClassify: Array,
      yearWorkClassify: Array,
      yearCompleteList: Array,
    },
    data() {
      return {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
        allTableData: [],
        tableData: [],
        isBatch: false,
        detailData: {},
        transferTableData: [],
        approveStateList: [
          {value: 0, label: '未处理'},
          {value: 1, label: '通过'},
          {value: 2, label: '驳回'},
          {value: 3, label: '撤回'},
        ]
      }
    },
    watch: {
      rowData: {
        handler(newVal) {
          this.pageIndex = 1;
          this.total = newVal.resWks.length;
          this.isBatch = newVal.groupId && newVal.groupId !== '00000000-0000-0000-0000-000000000000';
          this.detailData = {};
          this.transferTableData = [];

          if (newVal.type === 'month' || newVal.type === 'todoWork') {
            if (this.isBatch) {
              this.getMonthGroupList();
            } else {
              this.getMonthList();
            }
          } else if (newVal.type === 'year') {
            if (this.isBatch) {
              this.getYearGroupList();
            } else {
              this.getYearList();
            }
          }
        },
        immediate: true,
      }
    },
    created() {},
    methods: {
      getMonthList() {
        const params= {id : this.rowData.id};
        this.$ajax.get(this.$api.add.released.detailList, params).then((res) => {
          if (res.code === 0) {
            const tableData = res.data ? res.data.resultList || [] : [];
            this.detailData = tableData[0] || {};
            this.setTableData();
          }
        });
      },
      getMonthGroupList() {
        const params= {groupId : this.rowData.groupId};
        this.$ajax.get(this.$api.add.released.detailListByGroup, params).then((res) => {
          if (res.code === 0) {
            const list = (res.data.result || []).filter(item => item.detailItem);
            this.allTableData = list.map(item => {
              const {isShowTransfer, transferList} = this.handleTransferData(item.group, item.detailItem);
              const monthList = [...item.currInMonthList, ...item.currHandoverList]
              monthList.sort((a, b) => {
                if (b.year !== a.year) {
                  return b.year - a.year;
                }
                return b.month - a.month; 
              })
              const filterMonthList = [];
              const ids = [];
              monthList.forEach(item => {
                if (!ids.includes(item.d.id)) {
                  ids.push(item.d.id);
                  filterMonthList.push(item);
                }
              })
              return {
                currInMonthList: filterMonthList,
                isShowTransfer,
                transferList,
                ...item.detailItem,
                titleCol: item.item ? item.item.title : ''
              }
            });
            this.setTableData();
          }
        });
      },
      getYearList() {
        const params= {id : this.rowData.id};
        this.$ajax.get(this.$api.add.released.yearDetailList, params).then((res) => {
          if (res.code === 0) {
            const tableData = res.data ? res.data.resultList || [] : [];
            this.detailData = tableData[0] || {};
            this.setTableData();
          }
        });
      },
      getYearGroupList() {
        const params= {groupId : this.rowData.groupId};
        this.$ajax.get(this.$api.add.released.yearDetailListByGroup, params).then((res) => {
          if (res.code === 0) {
            const list = (res.data.result || []).filter(item => item.detailItem);
            this.allTableData = list.map(item => {
              const {isShowTransfer, transferList} = this.handleTransferData(item.group, item.detailItem);
              return {
                currInMonthList: item.currInMonthList,
                currInYearList: item.currInYearList,
                isShowTransfer,
                transferList,
                ...item.detailItem,
                titleCol: item.item ? item.item.title : ''
              }
            });
            this.setTableData();
          }
        });
      },
      handleTransferData(list = [], detailItem) {
        const transferList = [];
        list.forEach(item => {
          item.extendObj = JSON.parse(item.extend || '{}');
          if (item.transferHandoverType === 'TransferWork') {
            if (detailItem && item.transferHandoverWorkId === detailItem.id) {
              transferList.push(item);
            }
          } else {
            transferList.push(item);
          }
        })
        return {
          isShowTransfer: transferList.length > 0,
          transferList,
        }
      },
      formatDate(value, format) {
        return XEUtils.toDateString(value, format);
      },
      expandRow({rowIndex}) {
        this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
        this.$refs.tableEl.updateData(this.tableData);
      },
      handledPageChange() {
        this.setTableData();
      },
      setTableData() {
        this.tableData = this.allTableData.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize);
      },
      workClassifyName() {
        if (this.rowData.type==="month" || this.rowData.type === "todoWork"){
          return this.monthWorkClassify.length > 0 && this.monthWorkClassify.find(t => t.itemValue === this.rowData.workClassify.toString()) && this.monthWorkClassify.find(t => t.itemValue === this.rowData.workClassify.toString()).itemDesc;
        } else {
          return this.yearWorkClassify.length > 0 && this.yearWorkClassify.find(t => t.itemValue === this.rowData.workClassify.toString()) && this.yearWorkClassify.find(t => t.itemValue === this.rowData.workClassify.toString()).itemDesc;
        }
      },
      getYearStatusName(val) {
        const obj = this.yearCompleteList.find(t => t.itemValue == val);
        return obj ? obj.itemDesc : '';
      },
      showTransfer(row) {
        this.transferTableData = row.transferList;
      },
      getApproveState(state) {
        const result = this.approveStateList.find(item => item.value == state);
        return result ? result.label : '';
      },
      expandVisibleMethod({ row }) {
        if ((row.currInMonthList && row.currInMonthList.length > 0) || (row.currInYearList && row.currInYearList.length > 0)) {
          return true
        }
        return false
      }
    }
  }
</script>
<style scoped lang='scss'>
.detail-rows {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.page-con {
  flex: 0 0 56px;
}
.detail-wrap {
  padding: 16px;
  height: calc(100% - 48px);
  border: 1px solid #eee;
  overflow: auto;
  font-size: 14px;
  border-radius: 12px;
}
.detail-item {
  margin-bottom: 16px;
  color: #333;
}
.item-title {
  font-weight: bold;
  padding-bottom: 8px;
  font-size: 15px;
}
.item-content {
  word-wrap: break-word;
}
.transfer-icon {
  margin-left: 4px;
  cursor: pointer;
  color: $--color-primary;
  vertical-align: -1px;
  &:hover {
    opacity: 0.8;
  }
}
.year-to-month-wrapper {
  padding: 12px;
}
</style>